/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomerCollectionContactMethod {
    Unknown = 0,
    CustomerEmail = 1,
    PhoneCall = 2,
    SalespersonEmail = 3,
    Other = 4,
    Website = 5,
    OPS = 6,
}
